import { Typography } from '../Typography/Typography.js';
import { getCategoryStyles, getCategoryIconStyles, getCategoryTextStyles, getCategoryRightContentStyles } from './CategoryStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Icon } from '../Icon/Icon.js';

const Category = _ref => {
  let {
    iconName,
    text,
    actionIconName,
    active = false,
    htmlElement = 'button',
    onClick,
    rightContent,
    ...rest
  } = _ref;
  return jsxs(Typography, {
    bold: true,
    variant: "body1",
    component: htmlElement,
    onClick: onClick,
    css: getCategoryStyles(active, !!rightContent),
    title: text,
    ...rest,
    children: [jsx(Icon, {
      css: getCategoryIconStyles({
        marginRight: true
      }),
      name: iconName
    }), jsx("strong", {
      css: getCategoryTextStyles,
      children: text
    }), actionIconName && jsx(Icon, {
      css: getCategoryIconStyles({
        marginLeft: true
      }),
      name: actionIconName
    }), rightContent && jsx("div", {
      css: getCategoryRightContentStyles(),
      children: rightContent
    })]
  });
};

export { Category };
//# sourceMappingURL=Category.js.map
